
import { getInitials } from '@/utils/initials';

const AVATAR_PALETTE_DARK = [
  ['rgba(30,58,138,0.45)',  '#BFDBFE'],
  ['rgba(20,83,45,0.45)',   '#BBF7D0'],
  ['rgba(146,64,14,0.45)',  '#FED7AA'],
  ['rgba(76,29,149,0.45)',  '#DDD6FE'],
  ['rgba(127,29,29,0.45)',  '#FECACA'],
  ['rgba(120,53,15,0.45)',  '#FDE68A'],
  ['rgba(21,94,117,0.45)',  '#A5F3FC'],
  ['rgba(157,23,77,0.45)',  '#FBCFE8'],
];
const AVATAR_PALETTE_LIGHT = [
  ['#DBEAFE', '#1E40AF'], ['#DCFCE7', '#166534'], ['#FFEDD5', '#C2410C'],
  ['#EDE9FE', '#5B21B6'], ['#FEE2E2', '#991B1B'], ['#FEF3C7', '#92400E'],
  ['#CFFAFE', '#155E75'], ['#FCE7F3', '#9D174D'],
];
function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return Math.abs(h);
}

export function VFProspectAvatar({
  initials,
  isBeingCalled,
  callStatus,
}: {
  initials: string;
  isBeingCalled?: boolean;
  callStatus?: string;
}) {
  // Correction #7 — couleur neutre unique pour tous les ronds d'initiales.
  // Les palettes par hash restaient un bruit visuel : la couleur ne portait
  // aucune information, elle entrait juste en concurrence avec les couleurs de
  // statut d'appel, qui elles ont un sens. Tokens thematiques : gris clair en
  // clair, gris sombre en sombre, sans code couleur par personne.
  const bg = 'var(--vf-surface-3, #EDEEF1)';
  const fg = 'var(--vf-text-2, #52525B)';
  const ring = '1px solid var(--vf-border, #E7E7EA)';

  if (isBeingCalled) {
    // Couleur du ring selon l'etat reel : vert = humain en ligne, orange = sonne,
    // jaune = numerotation, violet = AMD en analyse
    const dotColor = callStatus === 'connected_to_agent' || callStatus === 'human_detected'
      ? 'var(--vf-green)'
      : callStatus === 'ringing'
      ? 'var(--vf-orange)'
      : callStatus === 'ai_analyzing'
      ? 'var(--vf-accent)'
      : 'var(--vf-yellow)';
    return (
      <span
        className="relative flex items-center justify-center rounded-full shrink-0 overflow-hidden"
        style={{ width: 28, height: 28, background: bg, color: fg, border: ring, fontSize: 10, fontWeight: 700 }}
      >
        <span className="absolute inset-0 rounded-full vf-pulse" style={{ background: dotColor, opacity: 0.35 }} />
        <span className="relative">{initials}</span>
      </span>
    );
  }

  return (
    <span
      className="flex items-center justify-center rounded-full shrink-0"
      style={{ width: 28, height: 28, background: bg, color: fg, border: ring, fontSize: 10, fontWeight: 700 }}
    >
      {initials}
    </span>
  );
}
